import { apiClient } from './apiClient';

export interface TenantMeStorageInfo {
  backend: string;
  bucket: string | null;
  key_prefix: string | null;
  region: string | null;
}

export interface TenantMeRead {
  id: string;
  name: string;
  slug: string;
  auth_mode: string;
  extraction_policy: string;
  extraction_schedule_cron: string | null;
  ingestion_modes_enabled: Record<string, boolean>;
  storage: TenantMeStorageInfo;
  is_active: boolean;
  created_at: string;
}

export interface TenantMeUser {
  user_id: string;
  username: string;
  email: string;
  full_name: string | null;
  role: string;
  is_active: boolean;
}

export interface TenantMeDomainConfig {
  domain_code: string;
  prompt_name: string | null;
  schema_name: string | null;
  ocr_config_name: string | null;
  llm_config_name: string | null;
}

export const tenantMeService = {
  async getMe(): Promise<TenantMeRead> {
    const res = await apiClient.get<TenantMeRead>('/tenant/me');
    return res.data;
  },
  async getMyUsers(): Promise<TenantMeUser[]> {
    const res = await apiClient.get<TenantMeUser[]>('/tenant/me/users');
    return res.data;
  },
  async getMyDomains(): Promise<TenantMeDomainConfig[]> {
    const res = await apiClient.get<TenantMeDomainConfig[]>('/tenant/me/domains');
    return res.data;
  },
};
